export type Tag = { id: number, count: number, description: string, name: string, slug: string }
export type IIndexCategory = {
  id: number
  name: string
  slug?: string
  headline?: string,
  img?: string,
}

export type IFScaleData = {
  'Made </br> In': string,
  Brand: string,
  Diameter: number,
  'Finish Type': string,
  Tensile: number,
  Category: string,
  'Rank': number,
  'F Rating': number,
  RWH: string,
  'High Repetition - </br> CrossFit Affiliate': number,
  'OLY Gym': number,
  'Garage </br> Gym': number,
  'Power </br> lifting Gym': number,
  // video: string,
  [key: string]: string | number;
}

export const FEATURED_CATEGORY_ID = 26
export const FEATURED_INDEX_PAGE_ID = 101

export const INDEX_CATEGORIES: IIndexCategory[] = [
  {
    id       : 19,
    name     : 'History',
    slug     : 'history',
    headline : 'History',
    img      : '/theindex/2023%20Headers/new%20-%202000%20x%20300/history_dzfcyi.jpg',
  },
  {
    id       : 103,
    name     : 'Documentary',
    slug     : 'documentary',
    headline : 'Documentary',
    img      : '/theindex/2023%20Headers/new%20-%202000%20x%20300/docs_eo6n5z.jpg',
  },
  {
    id       : 105,
    name     : 'News & Press',
    slug     : 'news',
    headline : 'News',
    img      : '/theindex/2023%20Headers/new%20-%202000%20x%20300/news_zavbjt.jpg',
  },
  {
    id       : 330,
    name     : 'Athletes',
    slug     : 'athletes',
    headline : 'Rogue Athletes',
    img      : '/theindex/2023%20Headers/new%20-%202000%20x%20300/athletes-2_ihlugx.jpg',
  },
  {
    id       : 18,
    name     : 'Events',
    slug     : 'events',
    headline : 'Events',
    img      : '/theindex/2023%20Headers/new%20-%202000%20x%20300/events_f2msv5.jpg',
  },
  {
    id       : 104,
    name     : 'Lifestyle',
    slug     : 'lifestyle',
    headline : 'Lifestyle',
    img      : '/theindex/2023%20Headers/new%20-%202000%20x%20300/lifestyle-2_rygihl.jpg',
  },
  {
    id       : 804,
    name     : 'Gym Tours',
    slug     : 'gym-tours',
    headline : 'Gym Tours',
    img      : '/theindex/Headers/Gym_Tour_indexheader__is3gaq.png',
  },
  {
    id       : 805,
    name     : 'Movement Library',
    slug     : 'movement-library',
    headline : 'Movement Library',
    img      : '/theindex/Headers/movement_gjkjcn_tfojfd.jpg',
  },
  {
    id       : 806,
    name     : 'Gear & How To',
    slug     : 'gear-how-tos',
    headline : 'Gear & How To',
    img      : '/theindex/Headers/Gear_HowTo_indexheader__crn0kj.png',
  },
  // 'Blog Posts' category is not currently being used.
  // {
  //   id       : 807,
  //   name     : 'Blog Posts',
  //   slug     : 'blog-posts',
  //   headline : 'Blog Posts',
  //   img      : '/theindex/Headers/BlogPost2_indexheader__bianpd.png',
  // },
  { id: 15, name: 'FeaturedFull' },
  { id: 101, name: 'FeaturedCatPage' },
  { id: 17, name: 'Featured' },
  { id: 26, name: 'FeaturedTop' },
]

export const FSCALE_DATA: IFScaleData[] = [
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Stainless',
    Tensile                                      : 200000,
    Category                                     : '28.5MM Power',
    Rank                                         : 1,
    'F Rating'                                   : 100.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 200.00,
    'OLY Gym'                                    : 1500.00,
    'Garage </br> Gym'                           : 2857.14,
    'Power </br> lifting Gym'                    : 30000.00,
    url                                          : '/rogue-hybrid-power-bar',
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Black Zinc',
    Tensile                                      : 200000,
    Category                                     : '28.5MM Power',
    Rank                                         : 2,
    'F Rating'                                   : 7.21,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 14.42,
    'OLY Gym'                                    : 108.17,
    'Garage </br> Gym'                           : 206.03,
    'Power </br> lifting Gym'                    : 2163.35,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Bright Zinc',
    Tensile                                      : 190000,
    Category                                     : '28.5MM Power',
    Rank                                         : 3,
    'F Rating'                                   : 6.10,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 12.20,
    'OLY Gym'                                    : 91.49,
    'Garage </br> Gym'                           : 174.27,
    'Power </br> lifting Gym'                    : 1829.81,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Raw Steel',
    Tensile                                      : 190000,
    Category                                     : '28.5MM Power',
    Rank                                         : 4,
    'F Rating'                                   : 5.04,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 10.08,
    'OLY Gym'                                    : 75.56,
    'Garage </br> Gym'                           : 143.93,
    'Power </br> lifting Gym'                    : 1511.25,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 190000,
    Category                                     : '28.5MM Power',
    Rank                                         : 5,
    'F Rating'                                   : 0.79,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 1.57,
    'OLY Gym'                                    : 11.80,
    'Garage </br> Gym'                           : 22.47,
    'Power </br> lifting Gym'                    : 235.91,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Stainless',
    Tensile                                      : 200000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 1,
    'F Rating'                                   : 100.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 200.00,
    'OLY Gym'                                    : 1500.00,
    'Garage </br> Gym'                           : 2857.14,
    'Power </br> lifting Gym'                    : 30000.00,
    url                                          : '/the-ohio-bar-stainless-steel',
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Cerakote',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 2,
    'F Rating'                                   : 8.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 16.00,
    'OLY Gym'                                    : 120.00,
    'Garage </br> Gym'                           : 228.57,
    'Power </br> lifting Gym'                    : 2400.00,
    url                                          : '/the-ohio-bar-cerakote',
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Black Zinc',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 2,
    'F Rating'                                   : 8.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 16.00,
    'OLY Gym'                                    : 120.00,
    'Garage </br> Gym'                           : 228.57,
    'Power </br> lifting Gym'                    : 2400.00,
    url                                          : '/the-ohio-bar-black-zinc',
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'ECoat',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 2,
    'F Rating'                                   : 8.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 16.00,
    'OLY Gym'                                    : 120.00,
    'Garage </br> Gym'                           : 228.57,
    'Power </br> lifting Gym'                    : 2400.00,
    url                                          : '/the-ohio-bar-2-0-e-coat',
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Bright Zinc',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 5,
    'F Rating'                                   : 6.78,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 13.56,
    'OLY Gym'                                    : 101.71,
    'Garage </br> Gym'                           : 193.74,
    'Power </br> lifting Gym'                    : 2034.25,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Cerakote',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 6,
    'F Rating'                                   : 4.55,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 9.10,
    'OLY Gym'                                    : 68.26,
    'Garage </br> Gym'                           : 130.02,
    'Power </br> lifting Gym'                    : 1365.18,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Cerakote',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 7,
    'F Rating'                                   : 3.47,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 6.94,
    'OLY Gym'                                    : 52.03,
    'Garage </br> Gym'                           : 99.10,
    'Power </br> lifting Gym'                    : 1040.56,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Black Zinc',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 8,
    'F Rating'                                   : 2.63,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 5.27,
    'OLY Gym'                                    : 39.52,
    'Garage </br> Gym'                           : 75.28,
    'Power </br> lifting Gym'                    : 790.48,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Cerakote',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 9,
    'F Rating'                                   : 2.38,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 4.75,
    'OLY Gym'                                    : 35.64,
    'Garage </br> Gym'                           : 67.88,
    'Power </br> lifting Gym'                    : 712.70,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Black Zinc',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 10,
    'F Rating'                                   : 1.86,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 3.72,
    'OLY Gym'                                    : 27.88,
    'Garage </br> Gym'                           : 53.10,
    'Power </br> lifting Gym'                    : 557.58,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Cerakote',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 11,
    'F Rating'                                   : 1.38,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 2.76,
    'OLY Gym'                                    : 20.73,
    'Garage </br> Gym'                           : 39.48,
    'Power </br> lifting Gym'                    : 414.58,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 12,
    'F Rating'                                   : 0.96,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 1.92,
    'OLY Gym'                                    : 14.41,
    'Garage </br> Gym'                           : 27.44,
    'Power </br> lifting Gym'                    : 288.12,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Black Zinc',
    Tensile                                      : 205000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 13,
    'F Rating'                                   : 0.94,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 1.88,
    'OLY Gym'                                    : 14.13,
    'Garage </br> Gym'                           : 26.91,
    'Power </br> lifting Gym'                    : 282.57,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.50,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 190000,
    Category                                     : '28/28.5MM MULTI',
    Rank                                         : 14,
    'F Rating'                                   : 0.91,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 1.83,
    'OLY Gym'                                    : 13.70,
    'Garage </br> Gym'                           : 26.09,
    'Power </br> lifting Gym'                    : 273.92,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Stainless',
    Tensile                                      : 200000,
    Category                                     : '28MM OLY',
    Rank                                         : 1,
    'F Rating'                                   : 100.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 200.00,
    'OLY Gym'                                    : 1500.00,
    'Garage </br> Gym'                           : 2857.14,
    'Power </br> lifting Gym'                    : 30000.00,
    url                                          : '/rogue-pyrros-bar-28mm-stainless-steel',
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Cerakote',
    Tensile                                      : 215000,
    Category                                     : '28MM OLY',
    Rank                                         : 2,
    'F Rating'                                   : 6.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 12.00,
    'OLY Gym'                                    : 90.00,
    'Garage </br> Gym'                           : 171.43,
    'Power </br> lifting Gym'                    : 1800.00,
    url                                          : '/rogue-28mm-iwf-oly-bar-cerakote',
  },
  {
    'Made </br> In'                              : 'Sweden',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 215000,
    Category                                     : '28MM OLY',
    Rank                                         : 3,
    'F Rating'                                   : 1.59,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 3.19,
    'OLY Gym'                                    : 23.92,
    'Garage </br> Gym'                           : 45.56,
    'Power </br> lifting Gym'                    : 478.35,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 190000,
    Category                                     : '28MM OLY',
    Rank                                         : 4,
    'F Rating'                                   : 1.15,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 2.29,
    'OLY Gym'                                    : 17.21,
    'Garage </br> Gym'                           : 32.78,
    'Power </br> lifting Gym'                    : 344.20,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 190000,
    Category                                     : '28MM OLY',
    Rank                                         : 5,
    'F Rating'                                   : 1.07,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 2.14,
    'OLY Gym'                                    : 16.03,
    'Garage </br> Gym'                           : 30.54,
    'Power </br> lifting Gym'                    : 320.63,

  },
  {
    'Made </br> In'                              : 'Japan',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 28.00,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 200000,
    Category                                     : '28MM OLY',
    Rank                                         : 6,
    'F Rating'                                   : 0.75,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 1.50,
    'OLY Gym'                                    : 11.22,
    'Garage </br> Gym'                           : 21.38,
    'Power </br> lifting Gym'                    : 224.47,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Stainless',
    Tensile                                      : 200000,
    Category                                     : '29MM Power',
    Rank                                         : 1,
    'F Rating'                                   : 100.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 200.00,
    'OLY Gym'                                    : 1500.00,
    'Garage </br> Gym'                           : 2857.14,
    'Power </br> lifting Gym'                    : 30000.00,
    url                                          : '/rogue-45lb-ohio-power-bar-stainless',
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Black Zinc',
    Tensile                                      : 205000,
    Category                                     : '29MM Power',
    Rank                                         : 2,
    'F Rating'                                   : 8.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 16.00,
    'OLY Gym'                                    : 120.00,
    'Garage </br> Gym'                           : 228.57,
    'Power </br> lifting Gym'                    : 2400.00,
    url                                          : '/rogue-45lb-ohio-power-bar-black-zinc',
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Raw Steel',
    Tensile                                      : 205000,
    Category                                     : '29MM Power',
    Rank                                         : 2,
    'F Rating'                                   : 8.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 16.00,
    'OLY Gym'                                    : 120.00,
    'Garage </br> Gym'                           : 228.57,
    'Power </br> lifting Gym'                    : 2400.00,
    url                                          : '/rogue-45lb-ohio-power-bar-bare-steel',
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Cerakote',
    Tensile                                      : 205000,
    Category                                     : '29MM Power',
    Rank                                         : 2,
    'F Rating'                                   : 8.00,
    RWH                                          : 'Yes',
    'High Repetition - </br> CrossFit Affiliate' : 16.00,
    'OLY Gym'                                    : 120.00,
    'Garage </br> Gym'                           : 228.57,
    'Power </br> lifting Gym'                    : 2400.00,
    url                                          : '/rogue-45lb-ohio-powerlift-bar-cerakote',
  },
  {
    'Made </br> In'                              : 'Sweden',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Raw Steel',
    Tensile                                      : 215000,
    Category                                     : '29MM Power',
    Rank                                         : 5,
    'F Rating'                                   : 3.82,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 7.63,
    'OLY Gym'                                    : 57.23,
    'Garage </br> Gym'                           : 109.02,
    'Power </br> lifting Gym'                    : 1144.68,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Stainless',
    Tensile                                      : 200000,
    Category                                     : '29MM Power',
    Rank                                         : 6,
    'F Rating'                                   : 2.84,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 5.67,
    'OLY Gym'                                    : 42.54,
    'Garage </br> Gym'                           : 81.02,
    'Power </br> lifting Gym'                    : 850.72,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 190000,
    Category                                     : '29MM Power',
    Rank                                         : 7,
    'F Rating'                                   : 2.14,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 4.28,
    'OLY Gym'                                    : 32.07,
    'Garage </br> Gym'                           : 61.09,
    'Power </br> lifting Gym'                    : 641.42,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 216200,
    Category                                     : '29MM Power',
    Rank                                         : 8,
    'F Rating'                                   : 1.75,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 3.50,
    'OLY Gym'                                    : 26.24,
    'Garage </br> Gym'                           : 49.98,
    'Power </br> lifting Gym'                    : 524.74,
  },
  {
    'Made </br> In'                              : 'China',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Raw Steel',
    Tensile                                      : 210000,
    Category                                     : '29MM Power',
    Rank                                         : 9,
    'F Rating'                                   : 1.10,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 2.20,
    'OLY Gym'                                    : 16.51,
    'Garage </br> Gym'                           : 31.44,
    'Power </br> lifting Gym'                    : 330.15,
  },
  {
    'Made </br> In'                              : 'Japan',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Chrome',
    Tensile                                      : 200000,
    Category                                     : '29MM Power',
    Rank                                         : 10,
    'F Rating'                                   : 0.99,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 1.99,
    'OLY Gym'                                    : 14.91,
    'Garage </br> Gym'                           : 28.40,
    'Power </br> lifting Gym'                    : 298.25,
  },
  {
    'Made </br> In'                              : 'US',
    Brand                                        : 'Non-Rogue',
    Diameter                                     : 29.00,
    'Finish Type'                                : 'Bright Zinc',
    Tensile                                      : 250000,
    Category                                     : '29MM Power',
    Rank                                         : 11,
    'F Rating'                                   : 0.67,
    RWH                                          : 'No',
    'High Repetition - </br> CrossFit Affiliate' : 1.35,
    'OLY Gym'                                    : 10.11,
    'Garage </br> Gym'                           : 19.25,
    'Power </br> lifting Gym'                    : 202.17,
  },
]
export const INDEX_CATEGORY_MAP:{[key: number] : IIndexCategory} = {}
INDEX_CATEGORIES.forEach(cat => INDEX_CATEGORY_MAP[cat.id] = cat)
